const HisCopy = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg
      style = {_sx}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.8014 12.5781H15.8014C14.3287 12.5781 13.1348 13.772 13.1348 15.2448V27.2448C13.1348 28.7176 14.3287 29.9115 15.8014 29.9115H27.8014C29.2742 29.9115 30.4681 28.7176 30.4681 27.2448V15.2448C30.4681 13.772 29.2742 12.5781 27.8014 12.5781Z"
        stroke={strokeColor}
        strokeWidth="2.66837"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.80078 20.5755H6.46745C5.7602 20.5755 5.08193 20.2946 4.58183 19.7945C4.08173 19.2944 3.80078 18.6161 3.80078 17.9089V5.90885C3.80078 5.20161 4.08173 4.52333 4.58183 4.02324C5.08193 3.52314 5.7602 3.24219 6.46745 3.24219H18.4674C19.1747 3.24219 19.853 3.52314 20.3531 4.02324C20.8532 4.52333 21.1341 5.20161 21.1341 5.90885V7.24219"
        stroke={strokeColor}
        strokeWidth="2.66837"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisCopy;
